module.exports = __webpack_public_path__ + "static/media/instructivor5.1eb1aa8d.png";